import { faCalendar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import Button from '../../../Button';
import { menuDrawerItemProps } from '../../MenuDrawerItems';

const Veranstaltungen = () => {
  return (
    <Button
      title="Veranstaltungen"
      variant="menu"
      leftIcon={<FontAwesomeIcon icon={faCalendar} />}
      {...menuDrawerItemProps}
      link={{
        href: 'https://www.deutsche-bildung.de/mein-kundenportal/meine-termine/',
      }}
    />
  );
};

export default React.memo(Veranstaltungen);
